import Notes from './Notes'
import { useCreateNote } from '../hooks/useCreateNote'
import { getNotesQueryKey, useGetNotes } from '../hooks/useGetNotes'

export type EmployerNotesProps = {
  employerId: string
  subjectType?: string
  subjectId?: string
  displayExistingNotes?: boolean
}

const EmployerNotesImpl = ({
  employerId,
  subjectType,
  subjectId,
  displayExistingNotes = true,
}: EmployerNotesProps) => {
  const { data: notes, error, isLoading } = useGetNotes({ employerId, displayExistingNotes })
  const createNoteMutation = useCreateNote({ employerId, subjectType, subjectId })

  return (
    <Notes
      isLoading={isLoading}
      error={error}
      createNoteMutation={createNoteMutation}
      displayExistingNotes={displayExistingNotes}
      notes={notes || []}
      queryKey={getNotesQueryKey({ employerId })}
    />
  )
}

const EmployerNotes = (props: EmployerNotesProps) => (
  <EmployerNotesImpl {...props} />
)

export default EmployerNotes
